<div class="group-calendar" [class.loading]="isLoading">
  <header class="toolbar">
    <button
      mat-icon-button
      type="button"
      (click)="prevMonthClicked.emit()"
      aria-label="Forrige måned"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="month-pill">{{ monthLabel }}</span>
    <button
      mat-icon-button
      type="button"
      (click)="nextMonthClicked.emit()"
      aria-label="Næste måned"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
    @if (showSettingsButton) {
    <button
      class="settings-btn"
      mat-icon-button
      type="button"
      (click)="settingsClicked.emit()"
      aria-label="Indstillinger"
      matTooltip="Indstillinger"
    >
      <mat-icon>settings</mat-icon>
    </button>
    } @if (!showSettingsButton) {
    <span class="settings-spacer"></span>
    }
  </header>

  @if (monthData) {
  <div class="grid-scroll">
    <div
      class="grid"
      cdkDropListGroup
      [style.grid-template-columns]="gridTemplateColumns"
    >
      <div class="cell header sticky-col">Dag</div>
      @for (loc of locationOptions; track loc.guid) {
      <div class="cell header">{{ getLocationName(loc.guid) }}</div>
      }
      <div class="cell header">Andet</div>
      <div class="cell header week-col">Uge</div>
      @if (showGroupColumn) {
      <div class="cell header group-col">Gruppe</div>
      } @for (row of monthData.days; track row.dateKey) {
      <div class="cell day-num sticky-col">
        <span class="wd-letter">{{ getWeekdayLetter(row.dateKey) }}</span>
        <span>{{ row.dayOfMonth }}</span>
      </div>
      @for (loc of locationOptions; track loc.guid) {
      <div
        class="cell loc-cell"
        cdkDropList
        [cdkDropListData]="dropCellData(row, loc.guid)"
        [cdkDropListEnterPredicate]="canDropEvent"
        (cdkDropListDropped)="onEventDroppedInternal($event)"
        [class.blocked]="
          (requiresGroupForRow(row) && !hasGroupForRow(row)) ||
          !canEditCell(loc.guid)
        "
        [class.readonly]="!canEditCell(loc.guid)"
        [class.drop-target]="
          !row.cells[loc.guid] &&
          (!showGroupColumn || hasGroupForRow(row)) &&
          canEditCell(loc.guid)
        "
        [style.background-color]="
          getCellColor(row, loc.guid)
            ? getCellColor(row, loc.guid) + '1f'
            : null
        "
        (click)="onCellClickInternal(row, loc.guid)"
      >
        @if (row.cells[loc.guid]; as ev) {
        <span
          class="event-chip"
          cdkDrag
          cdkDragPreviewClass="event-chip"
          [cdkDragData]="dragEventData(ev, row, loc.guid)"
          [cdkDragDisabled]="!canEditCell(loc.guid)"
          (cdkDragStarted)="onDragStarted()"
          (cdkDragEnded)="onDragEnded()"
          (click)="onChipClickInternal($event, row, loc.guid)"
        >
          @if (canEditCell(loc.guid)) {
          <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
          }
          <span class="dot" [style.background-color]="getEventColor(ev)"></span
          >{{ ev.name }}
        </span>
        }
      </div>
      }
      <div
        class="cell loc-cell"
        cdkDropList
        [cdkDropListData]="dropCellData(row, 'other')"
        [cdkDropListEnterPredicate]="canDropEvent"
        (cdkDropListDropped)="onEventDroppedInternal($event)"
        [class.blocked]="
          (requiresGroupForRow(row) && !hasGroupForRow(row)) ||
          !canEditCell('other')
        "
        [class.readonly]="!canEditCell('other')"
        [class.drop-target]="
          !row.cells['other'] &&
          (!showGroupColumn || hasGroupForRow(row)) &&
          canEditCell('other')
        "
        [style.background-color]="
          getCellColor(row, 'other') ? getCellColor(row, 'other') + '1f' : null
        "
        (click)="onCellClickInternal(row, 'other')"
      >
        @if (row.cells['other']; as ev) {
        <span
          class="event-chip"
          cdkDrag
          cdkDragPreviewClass="event-chip"
          [cdkDragData]="dragEventData(ev, row, 'other')"
          [cdkDragDisabled]="!canEditCell('other')"
          (cdkDragStarted)="onDragStarted()"
          (cdkDragEnded)="onDragEnded()"
          (click)="onChipClickInternal($event, row, 'other')"
        >
          @if (canEditCell('other')) {
          <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
          }
          <span class="dot" [style.background-color]="getEventColor(ev)"></span
          >{{ ev.name }}
        </span>
        }
      </div>
      <div class="cell week-col week-num">
        {{ row.showWeekNumber ? row.weekNumber : "" }}
      </div>
      @if (showGroupColumn) {
      <div class="cell group-col" (click)="$event.stopPropagation()">
        @if (readOnlyGroupColumn) {
        <span class="group-label">{{ getGroupNames(row.user_group_ids ?? []) }}</span>
        } @else {
        <mat-form-field appearance="outline" class="group-multiselect" subscriptSizing="dynamic">
          <mat-select
            multiple
            [ngModel]="row.user_group_ids"
            (ngModelChange)="onGroupChangeInternal(row, $event)"
            placeholder="—"
          >
            @for (g of groups; track g.group_id) {
            <mat-option [value]="g.group_id">{{ g.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
      </div>
      } }
    </div>
  </div>
  } @if (templateStats.length > 0 && !isLoading) {
  <section class="stats-section">
    <div class="stats-header">
      <h3 class="stats-title">Statistik</h3>
      <span class="stats-subtitle">{{ monthLabel }} · Hele {{ viewYear }}</span>
    </div>
    <div class="stats-table-wrap">
      <table class="stats-table">
        <thead>
          <tr>
            <th class="template-col">Skabelon</th>
            @for (col of statsLocationColumns; track col.key) {
            <th>{{ col.name }}</th>
            }
          </tr>
          <tr class="period-row">
            <th></th>
            @for (col of statsLocationColumns; track col.key) {
            <th>
              <span class="period-label">Måned / År</span>
            </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of templateStats; track row.templateId) {
          <tr>
            <td class="template-cell">
              <div class="template-cell-inner">
                <span
                  class="color-swatch"
                  [style.background-color]="row.color"
                ></span>
                <span class="template-name">{{ row.templateName }}</span>
              </div>
            </td>
            @for (col of statsLocationColumns; track col.key) {
            <td class="count-cell">
              {{ getTemplateStatCount(row, col.key, "month") }} /
              {{ getTemplateStatCount(row, col.key, "year") }}
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
  } @if (locationOptions.length === 0 && !isLoading) {
  <p class="setup-hint">
    Ingen lokationer valgt. Åbn <strong>Indstillinger</strong> for at vælge
    kolonner og ugeplan.
  </p>
  } @if (!monthData && !isLoading) {
  <div class="empty">Ingen data</div>
  }
</div>
